export default __webpack_public_path__ + "static/PromptIconTwo-7fc718373120e89c9aaab5f89dad625d.png";